export const siteToDustinBaseContractEnumValue = {
  None: 0,
  DustinSweden: 1,
  DustinHomeSweden: 2,
  DustinNorway: 3,
  DustinHomeNorway: 4,
  DustinDenmark: 5,
  DustinHomeDenmark: 6,
  DustinFinland: 7,
  DustinHomeFinland: 8,
  DustinNetherlands: 9,
  DustinHomeNetherlands: 10,
  DustinBelgium: 11,
} as const

export type SiteKey = keyof typeof siteToDustinBaseContractEnumValue

export const createOptimizelyUserAttributes = (
  site: string,
  punchOutTicket: string | null | undefined,
  isMobile: boolean,
  deviceType: string | null | undefined,
  userAgent: string | null | undefined,
  userData: any
) => ({
  Site: siteToDustinBaseContractEnumValue[site as SiteKey] ?? 0,
  IsPunchOut: !!punchOutTicket,
  IsMobile: isMobile,
  DeviceType: deviceType || null,
  ContactId: userData?.contact?.id || null,
  CustomerId: userData?.contact?.customerId || null,
  $opt_user_agent: userAgent || null,
})

export const createEventDispatcher = (hasAnalyticsConsent: boolean) => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatchEvent: ({ url, httpVerb, params }: { url: string; httpVerb: string; params: any }) => {
    // Override the URL with the proxy URL / CNAME (without https in that case)
    // url = 'http://logx.optimizely.demo.training/v1/events'

    if (hasAnalyticsConsent) {
      fetch(url, {
        method: httpVerb,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      })
    }
  },
})
